import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import SystemDataService from '../../Services/SystemDataService';
import { ButtonSecondary } from '../Buttons/button-component';
import { getQuickCallData } from '../../Public/quick-call-data';
import MediaComponent from '../Media/media-component';

const QuickCallSection = ({
    title: overrideTitle,
    subtitle: overrideSubtitle,
    quickCallData: passedData,
    personImage: overridePerson,
}) => {
    const systemData = useSelector(state => state.systemData || {});
    const { dir = 'rtl', language = 'he', links = [] } = systemData;

    const defaultStrings = getQuickCallData(language);

    const title = overrideTitle || passedData?.title || defaultStrings.title;
    const paragraph = passedData?.paragraph || defaultStrings.paragraph;
    const btnLabel = passedData?.btnText || defaultStrings.btnText;

    // Rotation pool comes from content (per-client gallery cutouts); pick one per
    // mount so the reused section feels fresh. A prop can still pin a specific one.
    const pool = (passedData?.personImages || defaultStrings.personImages || []).filter(Boolean);
    const [rotatingPerson] = useState(() => (pool.length ? pool[Math.floor(Math.random() * pool.length)] : ''));
    const personImage = overridePerson || passedData?.personImage || rotatingPerson;

    const phone = SystemDataService.byLabel(links, 'Phone');
    const whatsapp = SystemDataService.byLabel(links, 'WhatsApp') || SystemDataService.byLabel(links, 'Whatsapp');
    const ctaHref = '/contact' || whatsapp?.url || phone?.url;

    return (
        <section
            dir={dir}
            className="relative w-full bg-primary-600 overflow-hidden"
        >
            <div className="relative max-w-7xl mx-auto px-4 md:px-8">
                <div className="flex flex-col md:flex-row md:items-stretch gap-6 md:gap-4">

                    {/* Copy + CTA, vertically centered against the (taller) visual */}
                    <div className="flex-1 flex flex-col justify-center items-center md:items-start text-center md:text-start pt-14 pb-6 md:py-20">
                        {title && (
                            <h2 className="max-w-[16ch] text-4xl md:text-6xl font-extrabold leading-[1.05] text-white">
                                {title}
                            </h2>
                        )}

                        {paragraph && (
                            <p className="mt-5 max-w-[46ch] text-base md:text-lg leading-relaxed text-primary-100/80">
                                {paragraph}
                            </p>
                        )}

                        <div className="mt-8 flex flex-col items-stretch gap-4 w-full max-w-xs">
                            <ButtonSecondary
                                size="md"
                                href={ctaHref}
                                className="!rounded-full !px-8 !py-3.5 text-lg font-bold"
                            >
                                {btnLabel}
                            </ButtonSecondary>

                            {phone?.url && (
                                <a
                                    href={phone.url}
                                    className="inline-flex items-center justify-center gap-2 rounded-full border border-white/30 px-8 py-3.5 text-lg font-bold text-white transition-colors hover:bg-white/10 hover:border-white"
                                >
                                    {phone.description || phone.label || 'Call now'}
                                </a>
                            )}
                        </div>
                    </div>

                    {/* Person cutout, stands on the section floor */}
                    {personImage && (
                        <div className="w-full md:w-[64%] flex justify-center md:justify-end self-end">
                            <MediaComponent
                                image={personImage}
                                alt=""
                                objectFit="contain"
                                useSekeleton={false}
                                wrapperClassName="w-[520px] sm:w-[640px] md:w-full max-w-[920px] aspect-[3/2]"
                                className="!object-bottom select-none"
                            />
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default QuickCallSection;
